import React, { type ReactNode, Suspense } from "react";

import { LoadingPage } from "@/components/LoadingPage";
import { MainLayout } from "@/components/layout/MainLayout";
import { Toaster } from "@/components/ui/toast";
import { useSettings } from "@/features/admin/hooks";
import { TimeoutWarningDialog } from "@/features/auth/components/TimeoutWarningDialog";
import { useIdleTimeout } from "@/features/auth/hooks";

const IdleTimeoutWrapper = React.memo(() => {
  const { settings } = useSettings();
  useIdleTimeout(
    settings.idleTimeout ? Number(settings.idleTimeout) : undefined,
  );

  return <TimeoutWarningDialog />;
});

function Wrappers({ children }: { children: ReactNode }) {
  return (
    <>
      <Toaster />
      <IdleTimeoutWrapper />
      {children}
    </>
  );
}

export function MainApp({
  children,
  sidebar,
}: {
  sidebar: ReactNode;
  children: ReactNode;
}) {
  return (
    <Wrappers>
      <MainLayout sidebar={sidebar}>
        <Suspense fallback={<LoadingPage />}>{children}</Suspense>
      </MainLayout>
    </Wrappers>
  );
}
